import React from "react";
import { hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  // Pre-rendered content exists, use hydration
  hydrateRoot(rootElement, <App />);
} else {
  // No pre-rendered content, use client-side rendering
  const { createRoot } = require("react-dom/client");
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
